import { render, staticRenderFns } from "./product-dates-dialog.vue?vue&type=template&id=4582bff2&scoped=true&"
import script from "./product-dates-dialog.vue?vue&type=script&lang=js&"
export * from "./product-dates-dialog.vue?vue&type=script&lang=js&"
import style0 from "./product-dates-dialog.vue?vue&type=style&index=0&id=4582bff2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4582bff2",
  null
  
)

export default component.exports